module.exports = __webpack_public_path__ + "fonts/tinymce.aefbfcb.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/tinymce/skins/lightgray/fonts/tinymce.ttf
// module id = 1097
// module chunks = 0